/* PanelLogin.js */
/* @author: anghello */

import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { Col, Row, Form, FormGroup, Button } from 'reactstrap';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import PasswordInput from './input/PasswordInput';
import * as Yup from 'yup';
import ForgotPasswordModal from './ForgotPasswordModal';

const schema = Yup.object().shape({
  username: Yup.string().required(Strings('email_username_is_required')),
  password: Yup.string().required(Strings('password_is_required')),
});

export default function PanelLogin() {
  const history = useHistory();
  const { login, toggleLoading } = useAuth();
  const { register, errors, handleSubmit } = useForm({
    validationSchema: schema,
  });

  const onSubmit = useCallback(async ({ username, password }) => {
    toggleLoading(true);
    username = username.toLowerCase();
    username = username.trim();

    try {
      await login({ username, password });
      history.replace('/dashboard');
    } catch (err) {
      if (err && err.message) {
        toast.error(err.message);
      } else {
        toast.error(Strings('error_has_ocurred'));
      }
    } finally {
      toggleLoading(false);
    }
  }, [login, history, toggleLoading]);

  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
  const toggleForgotPasswordModal = useCallback(() => {
    setOpenForgotPasswordModal(value => !value);
  }, []);

  return (
    <>
      <div className='mb-2 mb-0'>
        <small className="text-muted">&nbsp;</small>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Row>
          <Col md={12}>
            <FormGroup>
              <input
                type='text'
                name='username'
                placeholder={Strings('username_email')}
                ref={register}
                className='form-control pb-input-1 border-radius-4px'
                autoCapitalize='none'
              />
              {errors.username && (
                <p role='alert' className='text-danger txt-small-1'>
                  {errors.username.message}
                </p>
              )}
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup>
              <PasswordInput
                name='password'
                placeholder={Strings('password')}
                ref={register}
                className='form-control pb-input-1 border-radius-4px'
              />
              {errors.password && (
                <p role='alert' className='text-danger txt-small-1'>
                  {errors.password.message}
                </p>
              )}
            </FormGroup>
          </Col>
        </Row>

        <div className='mt-2 mb-2 d-flex justify-content-end'>
          <a
            href='#/'
            className='p'
            onClick={(evt) => {
              evt.preventDefault();
              toggleForgotPasswordModal();
            }}
          >
            {Strings('forgot_your_password')}
          </a>
        </div>

        <div className='d-flex justify-content-center'>
          <Button
            color='primary'
            size='lg'
            type='submit'
            onClick={handleSubmit(onSubmit)}
          >
            {Strings('login')}
          </Button>
        </div>
      </Form>

      <ForgotPasswordModal
        isOpen={openForgotPasswordModal}
        toggle={toggleForgotPasswordModal}
      />
    </>
  );
}
